import * as React from 'react';
import cx from 'classnames';

import {PresenceType} from '../../constants/PresenceType';

// @ts-ignore
import styles from './Pip.pcss';

interface Props {
    className?: string;
    presence?: PresenceType;
    isNotification?: boolean;
}

const Pip = ({className = '', isNotification = false, presence = PresenceType.ONLINE}: Props) => {
    const mapPresenceToStyle = {
        [PresenceType.ONLINE]: styles.online,
        [PresenceType.AWAY]: styles.away
    };

    const classNames: string = cx(className, styles.indicator, {
        [mapPresenceToStyle[presence]]: !isNotification,
        [styles.notification]: isNotification
    });

    return <span className={classNames} />;
};

export default Pip;
